import React, {useState} from 'react';
import {Label, TextWarning} from '../../../../../../components';
import CARD_OPTIONS from '../../../../../../utils/hooks/cardOption';
import {CardFieldContainer} from '../../styles';

export default ({Cardfield, label}) => {
  const [error, useError] = useState({status: '', message: ''});
  const elementOption: any = {placeholder: ''};
  if (label === 'CARD NUMBER') elementOption.showIcon = true;

  return (
    <>
      <CardFieldContainer>
        <Label
          text={label}
          color={'rgba(93,110,129,1);margin-top:0px;  letter-spacing: 0.66px;line-height: 25.2px;'}
          fontWeight={'600'}
          fontSize={'12px'}
        />
        <Cardfield
          options={{...elementOption, ...CARD_OPTIONS}}
          onChange={e => {
            useError({status: e.error ? 'error' : '', message: e.error?.message});
          }}
        />
        <TextWarning status={error.status} message={error.message} display={';font-size:14px;margin-top:0px'} />
      </CardFieldContainer>
    </>
  );
};
